export const gearProductsData = [
  {
    productName: "Exercise Tubing Set",
    images: ["exercise-tubing-main.png"],
    details: [
      "5 color-coded resistance bands for customizable intensity",
      "Includes handles, door anchor, ankle strap, and D-ring",
      "Perfect for full-body workouts, stretching, and rehab",
      "Lightweight and travel-ready with B3 drawstring bag",
      "Durable, high-quality tubing for long-lasting use",
      "Easy to attach and adjust for any fitness level",
    ],
    addToCartSku: "ExerTub",
  },
  {
    productName: "Duffle Bag",
    images: ["duffle-bag-main.png"],
    details: [
      "Foldable & Portable – Packs down easily for travel or storage",
      "Water-Resistant Material – Protects your gear from rain and sweat",
      "Adjustable Shoulder Strap",
      "Multiple Pockets for Organization: 2 small zippered pockets, side mesh pocket, dedicated shoe pocket, spacious main compartment for your B3 Bands, tubing, and workout essentials",
    ],
    addToCartSku: "DuffleBag",
  },
  {
    productName: "Shaker Cup – Multi-Compartment",
    images: ["shaker-main.png"],
    details: [
      "3-in-1 design: mix, store, and go",
      "Built-in compartments for your B3 Powders",
      "Leak-proof lid with secure snap cap and carry loop",
      "Durable, BPA-free plastic with bold B3 logo",
      "Easy to clean and perfect for gym, work, or travel",
    ],
    addToCartSku: "Shaker",
  },
  {
    productName: "Sling Backpack – Blue",
    images: ["backpack-bule-main.png"],
    details: [
      "Single-strap design for easy, on-the-go wear",
      "Spacious main compartment fits B3 Bands and daily essentials",
      "Zippered front and back pockets for wallet, keys, or phone",
      "Side mesh pocket for water bottle or quick-grab items",
      "Padded back panel for comfort during all-day wear",
    ],
    addToCartSku: "B3BackPk",
  },
  {
    productName: "Sling Backpack – Pink",
    images: ["backpack-pink-main.png"],
    details: [
      "Single-strap design for easy, on-the-go wear",
      "Spacious main compartment fits B3 Bands and daily essentials",
      "Zippered front and back pockets for wallet, keys, or phone",
      "Side mesh pocket for water bottle or quick-grab items",
      "Padded back panel for comfort during all-day wear",
    ],
    addToCartSku: "B3BackPkpn",
  },
];
